<div class="card card-box mb-5">
    <div class="row no-gutters">
        <div class="col-lg-5">
            <img alt="..." class="rounded-left img-fit-container" src="assets/images/stock-photos/stock-1.jpg"/>
        </div>
        <div class="col-lg-7">
            <div class="p-5">
                <img alt="..." class="w-25 d-block img-fluid" src="assets/images/illustrations/business_plan.svg">
                <h1 class="display-4 my-3 font-weight-bold">
                    Wonderful serenity has possession
                </h1>
                <p class="font-size-lg text-black">
                    A free hour, when our power of choice is untrammelled and when nothing prevents.
                </p>
                <p class="font-size-sm mb-3 text-black-50">
                    Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live
                    the
                    blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics
                </p>
                <a [routerLink]="" class="btn btn-primary btn-block">
                    Continue reading
                </a>
            </div>
        </div>
    </div>
</div>
